import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./HeroSlider.scss";

// slideData'dan duration'ı kaldırıyoruz, artık videonun kendisinden gelecek
const slideData = [
  {
    id: 1,
    smallTitle: "Vet İzmire Hoşgeldiniz",
    mainTitle: "Evcil Dostlarınız İçin Sevgi ve Güvenin Adresi",
    buttonText: "Daha Fazlasını Gör",
    src: "/slider0.jpg",
    type: "image",
    link: "/hakkimizda",
  },
  {
    id: 2,
    type: "video",
    src: "/videos/vid1.mp4",
  },
  {
    id: 3,
    smallTitle: "HİKAYELERİNE ORTAK OLUYORUZ",
    mainTitle: "Her Patinin Bir Öyküsü Var",
    buttonText: "Hikayeleri Oku",
    src: "/slider1.jpg",
    type: "image",
    link: "/pati-hikayeleri",
  },
  {
    id: 4,
    type: "video",
    src: "/videos/vid2.mp4",
  },
  {
    id: 5,
    smallTitle: "Vet İzmir Ailesi",
    mainTitle: "Uzman Ekibimizle Tanışın",
    buttonText: "Yazıları Oku",
    src: "/slider2.jpg",
    type: "image",
    link: "/hekimlerimizden",
  },
];

const SlideBackground = ({ slide }) => {
  if (slide.type === "video") {
    return (
      <video
        src={slide.src}
        className="slide-background-asset"
        // LOOP'u kaldırıyoruz, çünkü videonun bitmesini istiyoruz
        autoPlay
        muted
        playsInline
      />
    );
  }
  return (
    <img
      src={slide.src}
      alt={slide.mainTitle}
      className="slide-background-asset"
    />
  );
};

const HeroSlider = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const autoplayTimerRef = useRef(null);

  useEffect(() => {
    if (!swiperInstance) return;

    const handleSlideChange = () => {
      clearTimeout(autoplayTimerRef.current);

      // Önceki slayttaki videonun olay dinleyicisini temizleyelim
      swiperInstance.slides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (video) {
          video.onplaying = null;
        }
      });

      const activeSlideElement =
        swiperInstance.slides[swiperInstance.activeIndex];
      const videoElement = activeSlideElement.querySelector("video");
      const activeSlideData = slideData[swiperInstance.realIndex];

      if (videoElement) {
        // YENİ: Videoyu başlangıçta görünmez yap
        videoElement.style.opacity = 0;

        videoElement.currentTime = 0;
        videoElement.play();

        swiperInstance.autoplay.stop();

        // YENİ: Video gerçekten oynamaya başladığında onu görünür yap
        videoElement.onplaying = () => {
          videoElement.style.opacity = 1;
        };

        const onVideoEnd = () => {
          swiperInstance.slideNext();
          videoElement.removeEventListener("ended", onVideoEnd);
        };
        videoElement.addEventListener("ended", onVideoEnd);
      } else {
        swiperInstance.autoplay.start();
      }
    };

    swiperInstance.on("slideChangeTransitionEnd", handleSlideChange);

    // İlk slayt için de bu kontrolü bir kere çalıştır
    const initialSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (initialSlide) {
      handleSlideChange();
    }

    return () => {
      if (swiperInstance && !swiperInstance.destroyed) {
        swiperInstance.off("slideChangeTransitionEnd", handleSlideChange);

        // Slaytların içindeki tüm videoları bul ve duraklat
        swiperInstance.slides.forEach((slide) => {
          const video = slide.querySelector("video");
          if (video) {
            video.pause();
          }
        });
      }
      clearTimeout(autoplayTimerRef.current);
    };
  }, [swiperInstance]);

  return (
    <div className="hero-slider-container">
      <Swiper
        modules={[Navigation, EffectFade, Autoplay]}
        effect="fade"
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 5000, // Bu SADECE görseller için geçerli olacak
          disableOnInteraction: false,
        }}
        onSwiper={setSwiperInstance}
        className="my-hero-swiper"
      >
        {slideData.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="slide-wrapper">
              <SlideBackground slide={slide} />
              {slide.link && (
                <div className="slide-content">
                  <div className="slide-text-content">
                    <div className="small-title">
                      <h4>{slide.smallTitle}</h4>
                      <div className="title-border"></div>
                    </div>
                    <h1 className="main-title">{slide.mainTitle}</h1>
                    <NavLink to={slide.link}>
                      <button className="slide-button">
                        {slide.buttonText}
                      </button>
                    </NavLink>
                  </div>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="swiper-navigation-custom">
        <div
          className="swiper-button-prev-custom"
          onClick={() => swiperInstance?.slidePrev()}
        >
          <FaArrowLeft />
        </div>
        <div
          className="swiper-button-next-custom"
          onClick={() => swiperInstance?.slideNext()}
        >
          <FaArrowRight />
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
